import api from './axios';

export const login = (email, senha) =>
  api.post('/auth/login', { email, password: senha });

export const me = () =>
  api.get('/auth/me');

export const refresh = (refresh_token) =>
  api.post('/auth/refresh', { refresh_token });

export const logout = () =>
  api.post('/auth/logout').catch(() => {});

export const patchMe = (data) =>
  api.patch('/auth/me', data);

export const selecionarEmpresa = (id_usuario_portal, id_empresa_operadora, password) =>
  api.post('/auth/selecionar-empresa', { id_usuario_portal, id_empresa_operadora, password });

export const trocarEmpresa = (id_empresa_operadora) =>
  api.post('/auth/trocar-empresa', { id_empresa_operadora });

export const minhasEmpresas = () =>
  api.get('/auth/minhas-empresas');
